// p-slider__main（forbusiness）の画像スライダーを Swiper で表示する。
// 対象HTML（.js-slider）が無いページでは何もしない。
// data-hover 付き : 初期は停止し、ホバー中だけ連続スムーズにスライドする。
// data-hover 無し : 1.4秒ごとに自動でスライドを切り替える。
export function initSlider () {
  const sliders = document.querySelectorAll('.js-slider');
  if (!sliders.length || typeof Swiper === 'undefined') return;

  sliders.forEach((slider) => {
    const hoverOnly = slider.hasAttribute('data-hover');

    const swiper = new Swiper(slider, {
      slidesPerView: 1.15,   // SP: 1枚 + 両端 peek
      spaceBetween: 16,      // 1rem
      centeredSlides: true,
      loop: true,
      speed: hoverOnly ? 5000 : 600, // ホバー型は遅く連続、通常型は切替アニメ0.6秒
      autoplay: {
        delay: hoverOnly ? 0 : 1400, // ホバー型は連続、通常型は1.4秒ごと
        disableOnInteraction: false,
      },
      breakpoints: {
        569: {
          slidesPerView: 2.4, // タブレット: 2枚 + peek
          spaceBetween: 24,   // 1.5rem
        },
        769: {
          // 先方要望（2026-08-10 Figma）：大学ページの事業紹介写真（約282px）と
          // 同じくらいのサイズに縮小。1440px 表示時で 281px になる値。
          slidesPerView: 4.7,
          spaceBetween: 32,   // 2rem
        },
      },
    });

    // ホバー型:
    //  - 768px超（PC）      : 初期停止。マウスが乗っている間だけ動かす
    //  - 768px以下（SP/タブ）: ホバー不可のため常時流す
    if (hoverOnly) {
      const mqTouch = window.matchMedia('(max-width: 768px)');

      const applyState = () => {
        if (mqTouch.matches) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }
      };
      applyState();
      mqTouch.addEventListener('change', applyState);

      slider.addEventListener('mouseenter', () => {
        if (!mqTouch.matches) swiper.autoplay.start();
      });
      slider.addEventListener('mouseleave', () => {
        if (!mqTouch.matches) swiper.autoplay.stop();
      });
    }
  });
}
